import * as React from "react";
import { useHistory } from "react-router";
import View from "zq-ui-v3/components/View/View";
import Button from "zq-ui-v3/components/Button/Button";

const ErrorPage: React.FC = () => {
  const history = useHistory();
  return (
    <View className="con-center w-100 h-100 flex-column">
      <View className="h6 p-2">页面加载失败</View>
      <Button
        className="p-2"
        color="secondaryText"
        showType="outlined"
        title="返回"
        onClick={() => history.goBack()}
      />
    </View>
  );
};
export default ErrorPage;
